<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>
    <div v-show="!showSkeleton" class="text-h4 mb-2">Áudios</div>
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-text>
          <Dialog  :audio="audio" />
        </v-card-text> 

        <v-divider />

        <v-card-actions>
        <v-spacer />
            <v-btn color="blue darken-1" text @click="dialog = false">Sair</v-btn>
        </v-card-actions> 
      </v-card>  
    </v-dialog>
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataAudios"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn
              dark
              color="orangePcm"
              href="/pabx/cadastro/audios/criar"
              target="_blank"
              @click="handleGoToNewAudio"
            >
              Criar Áudio
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>
      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <v-row dense align="center" justify="center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    dark
                    color="bluePcm"
                    target="_blank"
                    v-bind="attrs"
                    v-on="on"
                    @click="openDialog(item)"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </template>
                <span>Uso</span>
              </v-tooltip>
              <PlayerAudio :file="playerAudio(item._id)" :archive="item._id" downloadable color="primary" />
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="deletar(item)" dark color="darkRed" v-bind="attrs" v-on="on" class="ml-2">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </v-row>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row align="center" justify="center">
          <div class="ml-4 mb-2 mt-2 grey--text">
            <p>Total de Áudios: {{ qtdAudios }}</p>
          </div>
          <v-spacer />
          <div class="pb-3">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { hostname } from '@/utils/hostname'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'

import audiosStore from '../_store'
import AudiosHttpService from '../_services/AudiosHttpService'
import PlayerAudio from '../_components/PlayerAudio'
import Dialog from '../_components/Dialog.vue'

export default {
  components: { PlayerAudio, ListPagination, Dialog },

  mixins: [pagesHomeMixins],

  data: () => ({
    headers: [
      {
        text: 'Áudio',
        value: 'description',
        align: 'left',
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
    dataAudios: [],
    snackbar: true,
    dialog: false,
    audio: {}
  }),
  computed: {
    ...mapGetters('audiosHomeModulePABXStore', ['getAudios']),

    numberOfPages() {
      return Math.ceil(this.dataAudios.length / this.itemsPerPage)
    },
    qtdAudios() {
      return this.dataAudios.length
    },
  },

  async created() {
    registerVuexModule(this.$store, 'audiosHomeModulePABXStore', audiosStore)

    await this.listarAudios()
    this.dataAudios = [...this.getAudios]
    this.showSkeleton = false
  },

  methods: {
    ...mapActions('audiosHomeModulePABXStore', ['listarAudios', 'listarAudioUse']),

    handleGoToNewAudio(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const goToNewAudio = this.$router.resolve({ name: 'Audios/criar' })
        window.open(goToNewAudio.href, '_blank')
      } else {
        this.$router.push({ name: 'Audios/criar' })
      }
    },

    async deletar(item) {
      let resultado = window.confirm(`Deseja remover o áudio "${item.description}"?`)
      if (resultado) {
        try {
          await AudiosHttpService.deleteAudio(item._id)
          this.dataAudios = this.dataAudios.filter(x => x._id !== item._id)
        } catch (error) {
          alert(error.response.data)
        }
      }
    },
    playerAudio(audio) {
      return `https://${hostname()}/backend/asterisk/player/audio/${audio}.wav`
    },
    async openDialog(audio) {
      await this.listarAudioUse(audio._id)
      this.audio = audio
      this.dialog = true
    }
  },
}
</script>
